import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  EnableEscCloseDirective,
  UiButtonComponent,
  UiToggleComponent,
} from '@ui';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';
import { UserSettingsModels } from '@share-models';

@Component({
  selector: 'app-change-auto-logout',
  standalone: true,
  imports: [
    MatTooltip,
    TranslatePipe,
    MatDialogClose,
    ReactiveFormsModule,
    UiToggleComponent,
    UiButtonComponent,
    UiButtonComponent,
  ],
  hostDirectives: [EnableEscCloseDirective],
  templateUrl: './change-auto-logout-modal.component.html',
  styleUrl: './change-auto-logout-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeAutoLogoutModalComponent implements OnInit {
  public data = inject<{ settings: UserSettingsModels.UserSettingsDocument }>(
    MAT_DIALOG_DATA,
  );
  private dialogRef = inject(MatDialogRef<ChangeAutoLogoutModalComponent>);
  private fb = inject(FormBuilder);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);

  public formGroup = this.fb.group({
    autoLogoutEnabled: [false],
    autoLogout: [
      60,
      [Validators.required.bind(Validators), Validators.pattern('^[0-9]*$')],
    ],
  });

  public ngOnInit(): void {
    const userSettings = this.data?.settings;
    if (userSettings) {
      this.formGroup.patchValue({
        autoLogoutEnabled: userSettings.autoLogoutEnabled,
        autoLogout: userSettings.autoLogout,
      });
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    const formValue = this.formGroup.value;
    this.store$.dispatch(
      UserSettingsActions.startUpdateUserSettingsProcess({
        userSettings: {
          autoLogoutEnabled: !!formValue.autoLogoutEnabled,
          autoLogout: Number(formValue.autoLogout ?? 0),
        },
      }),
    );
    this.dialogRef.close();
  }
}
